import { get_turn_wgs_line } from "@/libs/turn-geometry";
import {
  getSourceIdByActiveCardId,
  getLayerIdByActiveCardId
} from "../configs";

// TODO: remove from release version
const demoIds = ["196", "203"];

const turnsStyle = {
  type: "line",
  layout: {
    "line-join": "round",
    "line-cap": "round"
  },
  paint: {
    "line-color": "#55b77e",
    "line-width": 3
  }
};
const pointsStyle = {
  type: "circle",
  paint: {
    "circle-radius": 4,
    "circle-color": "#55b77e",
    "circle-pitch-alignment": "map",
    "circle-stroke-color": "#fff",
    "circle-stroke-width": 1
  }
};
const arrowsStyle = {
  type: "symbol",
  layout: {
    "symbol-placement": "line",
    "text-field": "▶",
    "text-size": ["interpolate", ["linear"], ["zoom"], 12, 16, 22, 18],
    "symbol-spacing": ["interpolate", ["linear"], ["zoom"], 12, 24, 22, 32],
    "text-keep-upright": false
  },
  paint: {
    "text-color": "#55b77e",
    "text-halo-color": "#fff",
    "text-halo-width": 1
  }
};
const labelsStyle = {
  type: "symbol",
  layout: {
    "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
    "text-field": ["get", "time"],
    "text-pitch-alignment": "map",
    "symbol-placement": "line-center",
    "text-size": 18,
    "text-letter-spacing": 0.1
  },
  paint: {
    "text-color": [
      "case",
      [">", ["get", "time"], 3],
      "#55b77e",
      "rgba(229, 101, 102, 1)"
    ],
    "text-halo-color": "#fff",
    "text-halo-width": 1
  }
};

export class TrafficLightsController {
  constructor(parent) {
    this.mapgl = parent.mapgl;
    this.$store = parent.$store;

    // map ids
    this.pointsId = "traffic_lights_points";
    this.turnsId = "traffic_lights_turns";
    this.arrowsId = "traffic_lights_arrows";
    this.labelsId = "traffic_lights_labels";
    // timers
    this.drawTimer = null;
  }

  toggleTurns(active) {
    if (!active) return this.removeTurns();

    const sourceId = getSourceIdByActiveCardId(active);
    const sourceName = sourceId.replace("_sc_map", "");
    const id = getLayerIdByActiveCardId(active);
    if (!demoIds.includes(id)) return;
    if (sourceName === "chsmeo_traffic_light") this.addTurns(id);
  }

  // get data helpers
  async getPhasesData(id) {
    try {
      const url = `chsmeo_traffic_light_plan?id=${id}`;
      const { data } = await this.$store.dispatch("REQUEST", { url });

      return data;
    } catch (error) {
      console.log(error);

      return null;
    }
  }
  getTurnsFeatures(phase, time) {
    const { duration, turns } = phase;

    return {
      type: "FeatureCollection",
      features: turns.map(t => {
        const feature = get_turn_wgs_line(
          t.from_geom.coordinates,
          t.via_geom.coordinates,
          t.to_geom.coordinates,
          2,
          16
        );

        feature.properties = {
          duration: Number(duration),
          time
        };

        return feature;
      })
    };
  }
  getPointsFeatures(turns) {
    return {
      type: "FeatureCollection",
      features: turns.features.map(t => ({
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: t.geometry.coordinates[0]
        }
      }))
    };
  }
  // toggle map layers helpers
  addMapLayers(data) {
    const source = this.mapgl.getSource(this.turnsId);
    const pointsSource = this.mapgl.getSource(this.pointsId);
    const points = this.getPointsFeatures(data);

    if (!source) {
      // turns
      this.mapgl.addSource(this.turnsId, {
        type: "geojson",
        data
      });
      this.mapgl.addLayer({
        id: this.turnsId,
        source: this.turnsId,
        ...turnsStyle
      });
      this.mapgl.addLayer({
        id: this.arrowsId,
        source: this.turnsId,
        ...arrowsStyle
      });
      this.mapgl.addLayer({
        id: this.labelsId,
        source: this.turnsId,
        ...labelsStyle
      });

      // points
      this.mapgl.addSource(this.pointsId, {
        type: "geojson",
        data: points
      });
      this.mapgl.addLayer({
        id: this.pointsId,
        source: this.pointsId,
        ...pointsStyle
      });
    } else {
      source.setData(data);
      pointsSource.setData(points);
    }
  }
  clearTimers() {
    if (this.drawTimer) {
      clearTimeout(this.drawTimer);
      this.drawTimer = null;
    }
  }
  removeMapLayers() {
    this.clearTimers();

    if (this.mapgl.getLayer(this.turnsId)) this.mapgl.removeLayer(this.turnsId);
    if (this.mapgl.getLayer(this.pointsId))
      this.mapgl.removeLayer(this.pointsId);
    if (this.mapgl.getLayer(this.arrowsId))
      this.mapgl.removeLayer(this.arrowsId);
    if (this.mapgl.getLayer(this.labelsId))
      this.mapgl.removeLayer(this.labelsId);
    if (this.mapgl.getSource(this.turnsId))
      this.mapgl.removeSource(this.turnsId);
    if (this.mapgl.getSource(this.pointsId))
      this.mapgl.removeSource(this.pointsId);
  }

  async addTurns(id) {
    this.clearTimers();
    const phasesData = await this.getPhasesData(id);
    if (!phasesData) return this.removeMapLayers();

    const phases = Object.values(phasesData.phases);
    let index = 0;

    const drawPhase = () => {
      const phase = phases[index];
      const { duration } = phase;
      let time = duration;

      const drawLabels = () => {
        const data = this.getTurnsFeatures(phase, time);
        this.addMapLayers(data);
        time--;

        if (time !== 0) {
          this.drawTimer = setTimeout(() => drawLabels(), 1000);
        } else {
          if (index === phases.length - 1) index = 0;
          else index++;

          clearTimeout(this.labelTimer);
          this.drawTimer = setTimeout(() => drawPhase(index), 1000);
        }
      };

      drawLabels();
    };

    drawPhase(index);
  }

  removeTurns() {
    this.removeMapLayers();
  }
}
